import React, { useState } from "react";
import { Button, FormHelperText, Grid, Stack } from "@mui/material";
import Icon from "src/components/icon";
import styled from "styled-components";
import Link from "src/components/link";
import { Helmet } from "react-helmet";
import TextField from "@mui/material/TextField";
import request from "../../../utils/request";
import microsoft from "../../../assets/icons/microsoft";
import { useAuth } from "../../../components/providers/auth-context";

const H1 = styled.h1`
    font-size: 22px;
    margin: 0;
    font-weight: normal;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const H2 = styled.h2`
    font-size: 14px;
    font-weight: normal;
    margin: 0;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const P = styled.h2`
    font-size: 12px;
    font-weight: normal;
    margin: 0;
    ${({ theme }) => theme.breakpoints.up("sm")} {
        width: 50%;
    }
    color: ${({ theme }) => theme.palette.secondary.main};
`;

const PermissionsIcon = styled(Icon)`
    background-color: #fff;
    border-radius: 16px;
    padding: 24px 12px 24px 12px;
    margin: 32px 0 32px 0;
`;

const ContactPlaceholder =
    "In case of any inquiry regarding software permissions, please do not hesitate to ";

const PermissionsMicrosoft = () => {
    const { user } = useAuth();
    const [email, setEmail] = useState(user.emails[0]);
    const [error, setError] = useState();
    const type = "delegated";

    const handleClick = async () => {
        if (!type) {
            setError("Select how you want to integrate");
        } else if (type === "admin" && !email) {
            setError("Email is required for admin setup");
        } else {
            const { oauthUrl } = await request(
                `api/microsoft/oauth-url?type=${type}&email=${email}`
            );
            window.location.replace(oauthUrl);
        }
    };

    return (
        <>
            <Helmet>
                <title>Adadot - Microsoft Permissions</title>
            </Helmet>
            <Grid container justifyContent="center" mb={4}>
                <Stack
                    direction="column"
                    alignItems="flex-start"
                    style={{ height: "100%", width: "70%" }}
                >
                    <H1>Microsoft Integration</H1>
                    <H2>How adadot handles your Microsoft data</H2>
                    <Stack direction="row">
                        <PermissionsIcon svg={microsoft} width="100px" height="80px" />
                    </Stack>

                    <P style={{ marginTop: "12px", marginBottom: "24px" }}>
                        {ContactPlaceholder}
                        <Link to="/upgrade/inquiry">contact us</Link>
                    </P>
                    {type === "admin" && (
                        <TextField
                            required
                            fullWidth
                            style={{ maxWidth: "500px" }}
                            id="outlined-required"
                            label="Microsoft Email"
                            value={email}
                            onChange={(event) => {
                                setError(undefined);
                                setEmail(event.target.value);
                            }}
                        />
                    )}
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        onClick={handleClick}
                        style={{ width: "102px", marginTop: "32px" }}
                    >
                        Continue
                    </Button>
                    {error && <FormHelperText error>{error}</FormHelperText>}
                </Stack>
            </Grid>
        </>
    );
};

export default PermissionsMicrosoft;
